<template>
    <div class="booking-list p-3 w-100 mr-2">
        <h3 class="font-weight-bold">Buchungsübersicht</h3>
        <div v-if="requestedBookingCount" class="d-flex gap-3 flex-wrap" :class="row ? '' : 'flex-column'">
            <booking-card v-for="(booking, index) in requestBookingsAsList"
                          :booking="booking"
                          :keep="index === 0 || readOnly"
                          :key="'booking-list-' + booking.uuid"/>
        </div>
        <div v-else class="text-muted">
            Keine Buchungen
        </div>
    </div>
</template>

<script>

import resourceBookingsMixin from "@/mixins/resourceBookingsMixin";
import BookingCard from "@/components/farbcode-core/BookingCard";

export default {
    name: "BookingList",
    components: {BookingCard},
    mixins: [resourceBookingsMixin],
    props: {
        row: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            startVal: 0
        }
    },
}
</script>

<style scoped>
.booking-list {
    width: 500px;
}
</style>
